import {Injectable} from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {AuthenticationService} from "../authentication.service";
import {Observable} from "rxjs";

@Injectable()
export class AuthenticationGuard implements CanActivate {

    constructor(
        private authenticationService: AuthenticationService,
        private router: Router
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        if(this.authenticationService.authenticated)
            return Observable.of(true);

        // Not yet logged in, check refresh token
        return this.authenticationService.authenticateRefreshToken().map(refreshSucceeded => {
            if (!refreshSucceeded)
                this.router.navigate(['/login'], {queryParams: { returnUrl: state.url }});

            return refreshSucceeded;
        });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/route-can-activates/authentication-guard.service.ts